import React from "react";
import { FaTimes } from "react-icons/fa";

const DpModal = ({ isOpen, onClose, children }) => {
  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-75 flex justify-center items-center z-50"
      onClick={onClose}
    >
      <div
        className="relative bg-white p-4 rounded-lg max-h-[80vh] overflow-auto"
        onClick={(e) => e.stopPropagation()}
        style={{ maxHeight: "80vh" }}
      >
        <button
          onClick={onClose}
          className="absolute top-2 right-2 p-2 text-white bg-gray-700 rounded-full"
        >
          <FaTimes size={20} />
        </button>

        {children}
      </div>
    </div>
  );
};

export default DpModal;
